import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setPostBlockUser = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_USER_BLOCK
            });
            dispatch(Action.SetGetUserById(params.id));
        }
        catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostBlockUser as SetPostBlockUser
} 